import $ from 'jquery';
import Cookies from 'js-cookie';
import {
    eventNewsletterDismissPopup,
    eventNewsletterOpenPopup,
    eventNewsletterSubscribeSuccess,
    eventNewsletterSubscribeFail,
    eventNewsletterViewPopup,
} from '../matomo';
import {submitNewsletterUrl} from '../nutsandwoods';
import Popup from '../components/Popup.svelte';
import NewsletterForm from '../components/Newsletter/Form.svelte';
import {isPhone} from '../useragent';

type PopupTrigger = 'popUpShown' | 'popUpShownCart';

export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

let popup: Popup | undefined;

function show(which: PopupTrigger) {
    if(popup) return;
    setPopUpHasBeenShown(which);
    popup = new Popup({
        target: document.body,
        props: {
            slot: {Component: NewsletterForm},
            className: 'newsletter-popup',
        },
    });
    popup.$on('dismiss', () => {
        eventNewsletterDismissPopup();
    });
    popup.show();
}

function hide(delay: number) {
    if(!popup) return;
    const currentPopup = popup;
    popup = undefined;
    setTimeout(async () => {
        await currentPopup.hide();
        currentPopup.$destroy();
    }, delay);
}

function setPopUpHasBeenShown(which: PopupTrigger) {
    Cookies.set('less1Day', 'true', { expires: 1 });
    Cookies.set(which, 'true', { expires: 1000 });
}

function hasPopUpBeenShown(which: PopupTrigger) {
    return Cookies.get(which);
}

function isSubscribed() {
    return Cookies.get('subscribed');
}

function setSubscribed() {
    // cookie expires in 1000 Tagen
    Cookies.set('subscribed', 'true', { expires: 1000 });
}

const loeten1 = Date.now();

export function subscribe(email: string) {
    const form_data = {
        loeten: '',
        loeten1,
        loeten2: Date.now(),
        email,
    };
    return new Promise<void>((resolve, reject) => {
        $.ajax({
            method: 'post',
            url: submitNewsletterUrl(),
            data: form_data,
        }).done(() => {
            // hier speichern, dass sich der Benutzer beim Newsletter angemeldet hat:
            setSubscribed();
            eventNewsletterSubscribeSuccess();
            hide(4000);
            resolve();
        }).fail(() => {
            eventNewsletterSubscribeFail(email);
            reject();
        });
    });
}

function shouldShowPopup() {
    // Popup nur anzeigen wenn der Benutzer noch nicht angemeldet ist ...
    if(isSubscribed())
        return false;
    // ... nicht im Checkout ...
    if($('body').is('#page-checkout'))
        return false;
    // ... und auch nicht, wenn man im Newsletter-Formular ist.
    if($('.newsletter :focus').length)
        return false;
    return true;
}

let popupTimer: number | undefined;

export function restartPopupLogic() {
    if(popupTimer) {
        clearTimeout(popupTimer);
        popupTimer = undefined;
    }

    (async () => {
        const {cart} = await import('../yoocon-shop');
        if(cart.count() > 0) {
            // Wenn was im Warenkorb liegt, nach 5 Sekunden anzeigen,
            // aber nur einmalig.
            if(!hasPopUpBeenShown('popUpShown') && !hasPopUpBeenShown('popUpShownCart')) {
                popupTimer = setTimeout(() => {
                    popupTimer = undefined;
                    if(!shouldShowPopup()) return;
                    show('popUpShownCart');
                    eventNewsletterViewPopup();
                }, 5000);
            }
        } else {
            // Wenn der Warenkorb leer ist, dann einmalig nach 60 Sekunden
            // anzeigen, danach jeweils einmal am Tag nach 20 Sekunden.
            if(!hasPopUpBeenShown('popUpShown') && !hasPopUpBeenShown('popUpShownCart')) {
                popupTimer = setTimeout(() => {
                    popupTimer = undefined;
                    if(!shouldShowPopup()) return;
                    show('popUpShown');
                    eventNewsletterViewPopup();
                }, isPhone ? 180000 : 60000);
            } else if(!Cookies.get('less1Day')) {
                popupTimer = setTimeout(() => {
                    popupTimer = undefined;
                    if(!shouldShowPopup()) return;
                    show('popUpShown');
                    eventNewsletterViewPopup();
                }, isPhone ? 120000 : 20000);
            }
        }
    })();
}

restartPopupLogic();

$('.open-newsletter').on('click', (e) => {
    e.preventDefault();
    show('popUpShown');
    eventNewsletterOpenPopup();
});

{
    const query = new URLSearchParams(location.search);
    if(query.get('mtm_source') == 'newsletter')
        setSubscribed();
}

// show('popUpShown'); //Zum Newsletter-PopUp Testen
